import React, { FC, useEffect, useState } from 'react';

import { Api, Code } from '@.api';
import { Checkbox } from '@.ui';
import { Board } from '@/Components/Partials';
import { mapStationLogFileResourceToModel, StationLogFileModel, StationResource } from '@/entities/Station';
import { ConsoleDev } from '@/Lib/ConsoleDev';

import { FileLog } from './components';
import S from './StationFileLogs.module.scss';

interface StationFileLogsProps {
    station: StationResource;
    isLoggingEnabled: boolean;
}

export const StationFileLogs: FC<StationFileLogsProps> = (props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [stationFileLogs, setStationFileLogs] = useState<StationLogFileModel[]>([]);

    useEffect(() => {
        const load = async () => {
            setIsLoading(true);

            try {
                const response = await Api.stations().logFiles(props.station.id);

                if (response.code === Code.Success) {
                    setStationFileLogs(response.data.log_files.map(mapStationLogFileResourceToModel));
                }

                setIsLoading(false);
            } catch (error) {
                ConsoleDev.error('Failed fetch station log files ', error);
            } finally {
                setIsLoading(false);
            }
        };

        void load();
    }, [props.station.id]);

    const changeLoggingEnabled = async (isLoggingEnabled: boolean) => {
        if (isLoading) {
            return;
        }

        setIsLoading(true);

        try {
            await Api.stations().update(
                {
                    ...props.station,
                    currency_id: props.station.currency?.id || null,
                    status: props.station.status?.id || null,
                    is_logging_enabled: isLoggingEnabled,
                },
                props.station.id
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Board.Item className={S.root}>
                <Checkbox text="Is logging enabled" onChange={changeLoggingEnabled} value={props.isLoggingEnabled} isDisabled={isLoading} />
            </Board.Item>

            <div className={S.root__log_file_list}>
                {stationFileLogs.map((fileLog, index) => (
                    <FileLog key={fileLog.name + index} fileLog={fileLog} />
                ))}
            </div>
        </>
    );
};
